// extracted by mini-css-extract-plugin
module.exports = {"block":"Copyright_block__E3mok","fadeOut":"Copyright_fadeOut__Lw1FW"};